import pathName, {
  ADMIN,
  ANGANWADI_CENTER,
  ANGANWADI_HELPER,
  ANGANWADI_TEACHER,
  CHILD,
  COMMUNITY_HEALTH_CENTER,
  DASHBOARD_TXT,
  DISTRICT_COLLECTOR,
  DISTRICT_HEALTH_OFFICER,
  DISTRICT_HOSPITAL,
  DOCTOR,
  INSPECTION_OFFICER,
  NEW_DASHBOARD_TXT,
  PARENT,
  PUBLIC_HEALTH_CENTRE,
  USER_TXT,
} from '../../routing/pathName.constant'
import { userWiseRole } from '../../utils/constant'
import {
  AdminIcon,
  ClipboardIcon,
  DealerIcon,
  DigitalRetailerIcon,
  FieldEngineerIcon,
  HomeIcon,
  UserIcon,
} from '../../utils/icons'
import { include } from '../../utils/javascript'
import { tabKeys } from '../jobs/jobs.description'
import { userRelationKey } from '../userManagement/user.description'

const { HOME, JOBS } = pathName

const {
  admin,
  parent,
  doctor,
  child,
  districtCollector,
  inspectionOfficer,
  anganwadiCenter,
  anganwadiTeacher,
  anganwadiHelper,
  districtHealthOfficer,
  districtHospital,
  publicHealthCentre,
  communityHealthCentre,
} = userWiseRole

const { associate } = userRelationKey

const allUser = [
  admin,
  parent,
  child,
  districtCollector,
  inspectionOfficer,
  anganwadiCenter,
  anganwadiTeacher,
  anganwadiHelper,
  districtHealthOfficer,
  districtHospital,
  publicHealthCentre,
  communityHealthCentre,
  doctor,
]
const otherUsers = allUser.filter(
  user => !include([districtCollector, inspectionOfficer], user),
)

// const userChildrenList1 = [
//   {
//     key: ADMIN,
//     userId: admin,
//     Icon: AdminIcon,
//     label: 'user_Admin',
//     sidebar: allUser,
//     addEdit: [admin],
//     level: { menu: allUser },
//     userView: {
//       user_Hospital: [
//         {
//           payload: { roleId: hospital },
//         },
//       ],
//       user_HospitalStaff: [{ payload: { roleId: hospitalStaff } }],
//       user_Paediatrician: [{ payload: { roleId: paediatrician } }],
//       user_Parent: [{ payload: { roleId: parent } }],
//     },
//   },
//   {
//     key: HOSPITAL,
//     userId: hospital,
//     Icon: ProductManufactureIcon,
//     label: 'user_Hospital',
//     sidebar: [
//       admin,
//       parent,
//       hospitalStaff,
//       paediatrician,
//       paediatricianAssistant,
//     ],
//     addEdit: [admin],
//     level: { menu: [admin] },
//     userView: {
//       user_Parent: [
//         {
//           payload: { roleId: parent, relationType: associate },
//           addAssociate: [admin],
//         },
//       ],
//       user_HospitalStaff: [
//         {
//           payload: { roleId: hospitalStaff },
//         },
//       ],
//       user_Paediatrician: [
//         { payload: { roleId: paediatrician }, subTitle: 'user_Child' },
//         {
//           payload: { roleId: paediatrician, relationType: associate },
//           subTitle: 'user_Associate',
//           addAssociate: [admin],
//         },
//       ],
//     },
//     user_Children: [
//       {
//         payload: { roleId: children, relationType: associate },
//       },
//     ],
//     parent: { label: 'user_Admin', id: admin },
//   },
//   {
//     key: HOSPITAL_STAFF,
//     userId: hospitalStaff,
//     Icon: ContractorIcon,
//     label: 'user_HospitalStaff',
//     sidebar: [admin, hospital],
//     addEdit: [admin],
//     level: {
//       menu: [],
//       'sub-menu': [admin],
//     },
//     userView: {
//       user_Parent: [
//         {
//           payload: { roleId: parent, relationType: associate },
//           addAssociate: [admin],
//         },
//       ],
//       user_Hospital: [
//         {
//           payload: { roleId: hospital },
//         },
//       ],
//       user_Paediatrician: [
//         { payload: { roleId: paediatrician }, subTitle: 'user_Child' },
//         {
//           payload: { roleId: paediatrician, relationType: associate },
//           subTitle: 'user_Associate',
//           addAssociate: [admin],
//         },
//       ],
//       user_Children: [
//         {
//           payload: { roleId: children, relationType: associate },
//         },
//       ],
//     },
//     parent: { label: 'user_Hospital', id: hospital },
//   },
//   {
//     key: PAEDIATRICIAN,
//     userId: paediatrician,
//     Icon: DealerIcon,
//     label: 'user_Paediatrician',
//     sidebar: [admin, hospital, hospitalStaff, paediatricianAssistant, parent],
//     addEdit: [admin],
//     level: {
//       menu: [],
//       'sub-menu': [admin],
//     },
//     userView: {
//       user_Hospital: [
//         {
//           payload: { roleId: hospital },
//           subTitle: 'user_Parent',
//           // needParent: true,
//         },
//         {
//           payload: { roleId: hospital, relationType: associate },
//           subTitle: 'user_Associate',
//           addAssociate: [admin],
//           // needParent: true,
//         },
//       ],
//       user_PaediatricianAssistant: [
//         { payload: { roleId: paediatricianAssistant } },
//       ],
//       user_Parent: [
//         {
//           payload: { roleId: parent, relationType: associate },
//           addAssociate: [admin],
//           // needParent: true,
//         },
//       ],
//       user_Children: [
//         {
//           payload: { roleId: children, relationType: associate },
//         },
//       ],
//     },
//     parent: { label: 'user_Hospital', id: hospital },
//   },
//   {
//     key: PAEDIATRICIAN_ASSISTANT,
//     userId: paediatricianAssistant,
//     Icon: FieldEngineerIcon,
//     label: 'user_PaediatricianAssistant',
//     sidebar: [admin, paediatrician, parent],
//     addEdit: [admin],
//     className: 'sub-menu',
//     level: {
//       menu: [],
//       'sub-menu2': [admin, hospital, parent],
//     },
//     userView: {
//       user_Hospital: [
//         {
//           payload: { roleId: hospital },
//           subTitle: 'user_Parent',
//           // needParent: true,
//         },
//         {
//           payload: { roleId: hospital, relationType: associate },
//           subTitle: 'user_Associate',
//           addAssociate: [admin],
//           // needParent: true,
//         },
//       ],
//       user_Paediatrician: [{ payload: { roleId: paediatrician } }],

//       user_Parent: [
//         {
//           payload: { roleId: parent, relationType: associate },
//           addAssociate: [admin],
//           // needParent: true,
//         },
//       ],
//       user_Children: [
//         {
//           payload: { roleId: children, relationType: associate },
//         },
//       ],
//     },
//     parent: { label: 'user_Paediatrician', id: paediatrician },
//   },
//   {
//     key: DOCTOR,
//     userId: doctor,
//     Icon: UserIcon,
//     label: 'user_Doctor',
//     sidebar: allUser,
//     addEdit: [admin, districtAdministration],
//     level: { menu: [] },
//     userView: {},
//     parent: {
//       label: 'user_DistrictAdministration',
//       id: districtAdministration,
//     },
//   },
//   {
//     key: PARENT,
//     userId: parent,
//     Icon: DigitalRetailerIcon,
//     label: 'user_Parent',
//     sidebar: [
//       admin,
//       hospital,
//       hospitalStaff,
//       paediatrician,
//       paediatricianAssistant,
//       children,
//     ],
//     addEdit: [admin],
//     level: { menu: [admin] },
//     userView: {
//       user_Children: [
//         {
//           payload: { roleId: children },
//         },
//       ],
//       user_Hospital: [
//         {
//           payload: { roleId: hospital, relationType: associate },
//           addAssociate: [admin],
//         },
//       ],
//       user_Paediatrician: [
//         {
//           payload: { roleId: paediatrician, relationType: associate },
//           addAssociate: [admin],
//         },
//       ],
//     },
//     parent: { label: 'user_Admin', id: admin },
//   },
//   {
//     key: CHILDREN,
//     userId: children,
//     Icon: DealerIcon,
//     label: 'user_Children',
//     sidebar: allUser,
//     addEdit: [admin, parent],
//     level: { menu: [], 'sub-menu2': allUser },
//     userView: {},
//     parent: { label: 'user_Parent', id: parent },
//   },
// ]

const userChildrenList = [
  {
    key: ADMIN,
    userId: admin,
    Icon: AdminIcon,
    label: 'user_Admin',
    sidebar: otherUsers,
    addEdit: [admin],
    level: { menu: otherUsers },
    userView: {},
  },
  {
    key: DISTRICT_COLLECTOR,
    userId: districtCollector,
    Icon: DealerIcon,
    label: 'user_DistrictCollector',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [admin, inspectionOfficer, anganwadiCenter] },
    userView: {
      user_InspectionOfficer: [
        {
          payload: { roleId: inspectionOfficer },
        },
      ],
      user_AnganwadiCentre: [
        {
          payload: { roleId: anganwadiCenter },
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: INSPECTION_OFFICER,
    userId: inspectionOfficer,
    Icon: UserIcon,
    label: 'user_InspectionOfficer',
    sidebar: [admin, districtCollector, anganwadiCenter],
    addEdit: [admin, districtCollector],
    level: {
      menu: [districtCollector, anganwadiCenter],
      'sub-menu': [admin],
    },
    userView: {
      user_AssignedAnganwadiForInspection: [
        {
          payload: { roleId: anganwadiCenter, relationType: associate },
          addAssociate: [],
        },
      ],
    },
    parent: { label: 'user_DistrictCollector', id: districtCollector },
  },
  {
    key: DISTRICT_HEALTH_OFFICER,
    userId: districtHealthOfficer,
    Icon: DealerIcon,
    label: 'user_DistrictHealthOfficer',
    sidebar: [admin],
    addEdit: [admin],
    level: {
      menu: [admin],
      'sub-menu': [],
    },
    userView: {},
    parent: { label: 'user_DistrictCollector', id: districtCollector },
  },
  {
    key: DISTRICT_HOSPITAL,
    userId: districtHospital,
    Icon: FieldEngineerIcon,
    label: 'user_DistrictHospital',
    sidebar: [admin],
    addEdit: [admin],
    level: {
      menu: [admin],
      'sub-menu': [],
    },
    userView: {
      user_InspectionOfficer: [
        {
          payload: { roleId: inspectionOfficer },
        },
      ],
      user_AnganwadiCentre: [
        {
          payload: { roleId: anganwadiCenter },
        },
      ],
    },
    parent: { label: 'user_DistrictHealthOfficer', id: districtHealthOfficer },
  },
  {
    key: PUBLIC_HEALTH_CENTRE,
    userId: publicHealthCentre,
    Icon: UserIcon,
    label: 'user_PublicHealthCentre',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {},
    parent: { label: 'user_DistrictHospital', id: districtHospital },
  },
  {
    key: COMMUNITY_HEALTH_CENTER,
    userId: communityHealthCentre,
    Icon: DigitalRetailerIcon,
    label: 'user_CommunityHealthCentre',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {},
    parent: { label: 'user_DistrictHospital', id: districtHospital },
  },
  {
    key: ANGANWADI_CENTER,
    userId: anganwadiCenter,
    Icon: UserIcon,
    label: 'user_AnganwadiCentre',
    sidebar: [admin, districtCollector],
    addEdit: [admin, districtCollector],
    level: { menu: [admin, districtCollector] },
    userView: {
      user_InspectionOfficer: [
        {
          payload: { roleId: inspectionOfficer, relationType: associate },
          addAssociate: [],
        },
      ],
      user_PreviousInspections: [
        {
          viewJobs: true,
          payload: { jobType: tabKeys.inspection, active: false },
          addAssociate: [],
        },
      ],
    },
    parent: { label: 'user_DistrictCollector', id: districtCollector },
  },
  {
    key: ANGANWADI_TEACHER,
    userId: anganwadiTeacher,
    Icon: UserIcon,
    label: 'user_AnganwadiTeacher',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [anganwadiCenter], 'sub-menu': [admin] },
    userView: {},
    parent: { label: 'user_AnganwadiCentre', id: anganwadiCenter },
  },
  {
    key: ANGANWADI_HELPER,
    userId: anganwadiHelper,
    Icon: UserIcon,
    label: 'user_AnganwadiHelper',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [anganwadiCenter], 'sub-menu': [admin] },
    userView: {},
    parent: { label: 'user_AnganwadiCentre', id: anganwadiCenter },
  },
  {
    key: DOCTOR,
    userId: doctor,
    Icon: UserIcon,
    label: 'user_Doctors',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {},
    parent: { label: 'user_PublicHealthCentre', id: publicHealthCentre },
  },
  {
    key: PARENT,
    userId: parent,
    Icon: UserIcon,
    label: 'user_Parents',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {},
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: CHILD,
    userId: child,
    Icon: UserIcon,
    label: 'user_Child',
    sidebar: [admin],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {},
    parent: { label: 'user_Parent', id: parent },
  },
]

const sidebarMenus = [
  {
    key: HOME,
    Icon: HomeIcon,
    label: 'menu_Home',
    sidebar: otherUsers,
  },
  {
    key: USER_TXT,
    Icon: UserIcon,
    label: 'menu_User',
    sidebar: otherUsers,
    children: userChildrenList.map(prop => ({
      ...prop,
      key: `${USER_TXT}/${prop.key}`,
    })),
  },
  {
    key: `/${ANGANWADI_CENTER}`,
    Icon: UserIcon,
    label: 'user_AssignAnganwadiToInspectionOfficer',
    sidebar: [districtCollector],
  },
  {
    key: `${USER_TXT}/${INSPECTION_OFFICER}`,
    Icon: UserIcon,
    label: 'user_AssignInspectionOfficerToAnganwadi',
    sidebar: [districtCollector],
  },
  // {
  //   key: FIRST_AID,
  //   Icon: FirstAidKit,
  //   label: 'menu_FirstAid',
  //   sidebar: allUser,
  // },
  {
    key: JOBS,
    Icon: ClipboardIcon,
    label: 'job_InspectionJob',
    sidebar: allUser,
  },
  {
    key: DASHBOARD_TXT,
    Icon: HomeIcon,
    label: 'menu_Dashboard',
    sidebar: [districtCollector],
  },
  {
    key: NEW_DASHBOARD_TXT,
    Icon: HomeIcon,
    label: 'job_DashboardUpdated',
    sidebar: [districtCollector],
  },
  // {
  //   key: 'report',
  //   Icon: ReportIcon,
  //   label: 'menu_Report',
  //   disabled: true,
  //   sidebar: allUser,
  // },
  // {
  //   key: 'dataView',
  //   Icon: DataviewIcon,
  //   label: 'menu_DataView',
  //   disabled: true,
  //   sidebar: allUser,
  // },
  // {
  //   key: 'data-visualization',
  //   Icon: DataviewIcon,
  //   label: 'menu_DataViz',
  //   disabled: true,
  //   sidebar: allUser,
  // },
]

export { allUser, sidebarMenus, userChildrenList }
